"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PageEventTracker = _interopRequireDefault(require("../event-trackers/PageEventTracker"));

var _AppEventTracker = _interopRequireDefault(require("../event-trackers/AppEventTracker"));

var _configOptions = require("../constants/config-options");

var _defaultConfig = require("../config/default-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TrackingService =
/*#__PURE__*/
function () {
  /** Initialize the module with an instance of EventService and tracking configuration options.
   *
   * @param {EventService} eventService
   * @param {Object} trackingConfig
   */
  function TrackingService(eventService, trackingConfig) {
    _classCallCheck(this, TrackingService);

    this.trackingConfig = Object.assign({}, _defaultConfig.defaultTrackingConfig, trackingConfig); // Initialize trackers.

    this.appEventTracker = new _AppEventTracker["default"](eventService, this.trackingConfig);
    this.pageEventTracker = new _PageEventTracker["default"](eventService, this.trackingConfig);
  }
  /**
   * Start tracking events.
   */


  _createClass(TrackingService, [{
    key: "start",
    value: function start() {
      this.appEventTracker.start();
      this.pageEventTracker.start();

      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.AUTO_UNLOAD]) {
        // Stop tracking on unload.
        window.addEventListener('beforeunload', this.stop.bind(this));
      }
    }
    /**
     * Stop tracking events.
     */

  }, {
    key: "stop",
    value: function stop() {
      this.appEventTracker.stop();
      this.pageEventTracker.stop();
    }
  }]);

  return TrackingService;
}();

var _default = TrackingService;
exports["default"] = _default;
module.exports = exports.default;